import { render, staticRenderFns } from "./NewestVideosLines.vue?vue&type=template&id=01580656&scoped=true&"
import script from "./NewestVideosLines.vue?vue&type=script&lang=js&"
export * from "./NewestVideosLines.vue?vue&type=script&lang=js&"
import style0 from "./NewestVideosLines.vue?vue&type=style&index=0&id=01580656&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01580656",
  null
  
)

export default component.exports